export const enum OnboardingWizardTab {
    COMPANY_DETAILS = 1,
    CONTACT_DETAILS,
    DUE_DILIGENCE,
    DELIVERY_LOCATIONS,
    CONFIGURATION,
    USERS
}